import React from 'react';

import DIGenericHeader, { DiHeaderSkeleton } from './DIGenericHeader';

export default function DiHeader({ practice }) {
  const {
    paymentSettings: {
      shortBusinessName,
      address,
      city,
      state,
      postalCode,
      logo,
      formattedPhoneNumber,
    } = {},
  } = practice;

  if (practice == null) return <DiHeaderSkeleton />;

  return (
    <DIGenericHeader
      logo={logo.thumb}
      display={shortBusinessName}
      address={`${address} ${city}, ${state} ${postalCode}`}
      phone={formattedPhoneNumber}
    />
  );
}
